<template>
  <section>
    <stockTopMenu :curPosition="params.type === '1' ? '新闻详情' : '知识库详情'" :windowId="windowId" :module="params.type === '1' ? 'news' : 'knowledge'" >
      <div
          slot="descript"
          class="row align-center space-between"
          style="margin-left: 100px"
      ></div>
    </stockTopMenu>
    <iframe :src="currentSrc" style="width: 100%;height:94vh;border: 0 !important;"  :allowfullscreen="true"></iframe>
    <el-image-viewer
        v-if="showViewer"
        :on-close="handleCloseViewer"
        :url-list="previewImages"
        style="z-index: 9999;"
    />
  </section>
</template>

<script>
import {submitBrowseRecord} from '@/libs/http/api.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import tool from '@/utils/tool.js'
import stockTopMenu from "@/components/stockTopMenu.vue";

export default {
  name:'homeNewsDetail',
  components: {
    stockTopMenu,
    ElImageViewer
  },
  data() {
    return {
      // dialogVisible: false,
      params:null,
      time: 0,
      currentSrc:'',
      showViewer: false,
      previewImages: [],
      windowId:null
    }
  },
  created() {
    console.log(decodeURIComponent(window.location.search))
    let str = decodeURIComponent(window.location.search).split('?params=')[1]
    if(str.includes('&_s=')){
      let obj = str.split('&_s')[0]
      console.log('obj',obj)
      this.params = JSON.parse(obj)
      console.log('this.params',this.params,this.params.srcLink,this.params.newsItem)
    }else{
      console.log('str',str)
      this.params = JSON.parse(str)
      console.log('this.params',this.params,this.params.srcLink,this.params.newsItem)
    }


    this.time = new Date().getTime();
    let token = tool.data.get('TOKEN')
    let env = window.urlConfig === 'prod' ? 'production' : 'development'
    this.currentSrc = `${this.params.srcLink}&token=${token}&id=${this.params.newsItem.id}&env=${env}&channelType=1`
    this.windowId = `homeNewsDetail${this.params.newsItem.id}`
  },
  mounted() {
    window.addEventListener('message', this.handleImageClick);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('message', this.handleImageClick);
  },
  methods: {
    close() {
      submitBrowseRecord({
        newsId: this.params.newsItem["id"],
        browseSec: Math.ceil((new Date().getTime() - this.time) / 1000) + ""
      })
      this.$emit('close');
    },
     handleImageClick(event) {
      // 验证消息来源和类型
      if (event.data && event.data.type === 'IMAGE_CLICK') {
        // 设置预览图片列表并显示预览器
        this.previewImages = [event.data.src];
        this.showViewer = true;
      }
    },
    handleCloseViewer() {
      // 关闭预览器
      this.showViewer = false;
      this.previewImages = [];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
